var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"favourite",attrs:{"src":require("../../assets/images/article/favourite.svg"),"alt":""},on:{"click":_vm.handleCheckFavourite}})}
var staticRenderFns = []

export { render, staticRenderFns }